export function redirectToUrl(url: string) {
  window.location.assign(url);
}
